import type { RouterOutputs } from "@/trpc";
import type { ReactNode } from "react";
import { EditRestrictionNotice } from "../components/edit-restriction-notice";
import { useCredentialVaultEditing } from "./use-credential-vault-editing";

/** Organization records share the vault workflow while retaining BU authority. */
export function useOrgCredentialEditing({
  organizationBusinessUnitId,
  providerUserId,
  data,
  enabled = true,
  credentialViewId,
  expectedAffiliationId,
  onEditPersonalDetails,
  personalDetailsContent,
}: {
  organizationBusinessUnitId: string;
  providerUserId: string;
  data: RouterOutputs["credentials"]["getForBu"] | undefined;
  enabled?: boolean;
  credentialViewId?: string;
  expectedAffiliationId?: string;
  onEditPersonalDetails?: () => void;
  personalDetailsContent?: ReactNode;
}) {
  return useCredentialVaultEditing({
    scope: {
      kind: "organization",
      organizationBusinessUnitId,
      providerUserId,
      credentialViewId,
      expectedAffiliationId,
    },
    data: data ?? null,
    enabled,
    canEdit: data?.access.canEdit ?? false,
    uploadPresentation: "dropzone",
    onEditPersonalDetails,
    personalDetailsContent,
    restrictionNotice: data ? (
      <EditRestrictionNotice restriction={data.access.restriction} />
    ) : null,
  });
}
